import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { GridColDef } from '@mui/x-data-grid-pro'
import { tsLoginConfig } from '../../../Typescript/API_Response'
import { formatValueDateTime } from '../../../Functions/FormatValues'

export const ScreenCollectionCols = (
  loginConfig: tsLoginConfig | undefined,
): GridColDef[] => [
  {
    field: 'SampleRunID',
    headerName: 'ID',
    flex: 1 / 2,
  },
  {
    field: 'RunType',
    headerName: 'Run Type',
    flex: 1,
    valueFormatter: (value) =>
      getCodeSetLabelLookup(loginConfig, ['SampleRunTypeID'], value),
  },
  {
    field: 'RunDate',
    headerName: 'Date',
    flex: 1,
    valueFormatter: formatValueDateTime,
  },
  {
    field: 'Status',
    headerName: 'Status',
    flex: 1,
    valueFormatter: (value) =>
      getCodeSetLabelLookup(loginConfig, ['SampleRunStatusID'], value),
  },
]
